export class objContactosFrm {
    public codInterlocutor: string = '';

    public codContacto: number = null;
    public nomContacto: string = '';
    public dirContacto: string = '';
    public hobbyContacto: string = '';
    public telfContacto: string = '';
    public activoContacto: boolean = true;
    public palclContacto: string = '';
    public correoContacto: string = '';
    public cargoContacto: string = '';

    public codContactoCliente: number = null;
    public nomContactoCliente: string = '';
    public dirContactoCliente: string = '';
    public hobbyContactoCliente: string = '';
    public telfContactoCliente: string = '';
    public activoContactoCliente: boolean = true;
    public palclContactoCliente: string = '';
    public correoContactoCliente: string = '';
    public cargoContactoCliente: string = '';
    public felicitacion ?: Date;
    //TAB CLASES
    public codClase: number = null;
    public desClase: string = '';
    public codCodigoClase: string = '';
    public desCodigoClase: string = '';
}